<template>
    <section>
        <div :style="`z-index: 250; position: fixed; right: 7%; top: ${screen_width >= 1265 ? '33px' : '100px'}; width: auto`">
            <v-alert
                v-model="notif.show"
                transition="scroll-x-reverse-transition"
                :type="notif.type"
                :color="notif.color"
                dismissible
            >
                {{ notif.msg }}
            </v-alert>
        </div>
        <h1 style="margin: 0 auto;">
            <v-icon
                v-if="screen_width > 390"
                x-large
                elevation="10"
                class="white--text"
                style="height: 50px; width: 50px; background-color: #009688; border-radius: 25px; margin-right: 2%;"
            >
                {{ mdiHeartPulse }}
            </v-icon>
            <span>Rates</span>
        </h1>
        <v-card elevation="10" class="docInfoBody">
            <v-data-table
                :items="rateItems"
                :headers="headers"
                :items-per-page="-1"
                :hide-default-footer="true"
            >
                <template #top>
                    <v-card-title>
                        <v-row>
                            <v-col cols="10">
                                <v-autocomplete
                                    v-model="selectedHosp"
                                    outlined
                                    hide-details
                                    dense
                                    :items="items"
                                    label="Hospital Name"
                                    item-text="nameAndCode"
                                    item-value="ROW_N"
                                    return-object
                                    clearable
                                    color="teal"
                                    @change="getMsuRatesFunc"
                                    @click:clear="rateItems = []"
                                >
                                    <template #selection="data">
                                        <v-chip
                                            v-if="data.item.hosp_msu_code || data.item.group_id"
                                            small
                                            :color="data.item.type === 'SINGLE' ? 'teal' : 'blue'"
                                            class="white--text"
                                            style="font-weight: 700;"
                                        >
                                            {{ data.item.type === 'SINGLE' ? data.item.hosp_msu_code : data.item.group_id }}
                                        </v-chip> {{ data.item.hosp_name }}
                                    </template>
                                    <template #item="data">
                                        <v-chip
                                            v-if="data.item.hosp_msu_code || data.item.group_id"
                                            small
                                            :color="data.item.type === 'SINGLE' ? 'teal' : 'blue'"
                                            class="white--text"
                                            style="font-weight: 700;"
                                        >
                                            {{ data.item.type === 'SINGLE' ? data.item.hosp_msu_code : data.item.group_id }}
                                        </v-chip> &nbsp;{{ data.item.hosp_name }}
                                    </template>
                                </v-autocomplete>
                            </v-col>
                            <v-col :cols="2">
                                <v-btn
                                    color="success"
                                    :disabled="selectedHosp == null"
                                    class="float-right"
                                    width="100%"
                                    style="max-width: 170px;"
                                    @click="newRate"
                                >
                                    <v-icon small>
                                        {{ mdiPlus }}
                                    </v-icon> new
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-title>
                </template>
                <template #[`item.RATE_TYPE`]="{ item }">
                    <v-chip :color="item.RATE_TYPE === 'PACKAGE' ? '#00B831' : '#0087B8'" style="color: #DDD">
                        {{ item.RATE_TYPE }}
                    </v-chip>
                </template>
                <template #[`item.ACTIONS`]="{ item }">
                    <div style="width: 190px;">
                        <div v-if="item.RATE_TYPE === 'PACKAGE'" style="display: inline-block;">
                            <v-tooltip top>
                                <template #activator="{ on }">
                                    <v-btn
                                        icon
                                        color="primary"
                                        v-on="on"
                                        @click="showPackage(item)"
                                    >
                                        <v-icon>{{ mdiEye }}</v-icon>
                                    </v-btn>
                                </template>
                                <span>Show Package</span>
                            </v-tooltip>
                        </div>
                        <div v-else style="width: 38px; display: inline-block;">
&nbsp;
                        </div>
                        <v-tooltip top>
                            <template #activator="{ on }">
                                <v-btn
                                    icon
                                    :color="item.LINKS.length > 0 ? 'success' : 'gray'"
                                    v-on="on"
                                    @click="showLinkedModal(item, item.LINKS.length > 0 ? 'show' : 'add')"
                                >
                                    <v-icon>{{ item.LINKS.length > 0 ? mdiLinkEdit : mdiLinkPlus }}</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ item.LINKS.length > 0 ? 'Show' : 'Create' }} Linked Diagnostic/Package Name</span>
                        </v-tooltip>
                        <v-tooltip top>
                            <template #activator="{ on }">
                                <v-btn
                                    icon
                                    color="primary"
                                    v-on="on"
                                    @click="showHistory(item)"
                                >
                                    <v-icon>{{ mdiFileEye }}</v-icon>
                                </v-btn>
                            </template>
                            <span>Show History</span>
                        </v-tooltip>
                        <v-tooltip top>
                            <template #activator="{ on }">
                                <v-btn
                                    icon
                                    color="warning"
                                    v-on="on"
                                    @click="updateRate(item)"
                                >
                                    <v-icon>{{ mdiPencil }}</v-icon>
                                </v-btn>
                            </template>
                            <span>Edit {{ item.RATE_TYPE === 'PACKAGE' ? 'Package' : 'Diagnostic' }}</span>
                        </v-tooltip>
                        <v-tooltip top>
                            <template #activator="{ on }">
                                <v-btn
                                    icon
                                    color="error"
                                    v-on="on"
                                    @click="deleteRate(item)"
                                >
                                    <v-icon>{{ mdiTrashCan }}</v-icon>
                                </v-btn>
                            </template>
                            <span>Delete {{ item.RATE_TYPE === 'PACKAGE' ? 'Package' : 'Diagnostic' }}</span>
                        </v-tooltip>
                    </div>
                </template>
                <template #[`item.AGE`]="{ item }">
                    <span style="white-space: nowrap;">{{ makeAgeStatement(item) }}</span>
                </template>
                <template #[`item.PHP_N`]="{ item }">
                    <div v-if="item.USE_HMI_RATE" -style="white-space: nowrap; text-align: right;">
                        HMI Rate
                    </div>
                    <div v-else -style="white-space: nowrap; text-align: right;">
                        PHP {{ toFixedNoRound(item.PHP_N, 2) }}
                    </div>
                </template>
            </v-data-table>
        </v-card>
        <UpdateRate
            :show="show.update"
            :data="show.data"
            :rate-items="rateItems"
            @closeDialog="show.update = false"
        />
        <DeleteRate
            :show="show.delete"
            :data="show.data"
            @closeDialog="show.delete = false"
        />
        <NewRate
            :show="show.new"
            :data="show.data"
            :rate-items="rateItems"
            @closeDialog="show.new = false"
        />
        <ShowHistory
            :show="show.history"
            :data="show.historyData"
            @closeDialog="show.history = false"
        />
        <PackagePage
            :show="show.package"
            :data="show.packageData"
            :notif="notif"
            @closeDialog="show.package = false"
        />
        <LikedPage
            :show="show.linked"
            :data="show.data"
            :rate-items="rateItems"
            :notif="notif"
            @closeDialog="show.linked = false"
            @refreshMsuRates="getMsuRatesFunc"
            @showIndexPage="showIndexPage"
        />
        <NewLink
            :show="show.addLinked"
            :data="show.data"
            :rate-items="rateItems"
            :notif="notif"
            @refreshMsuRates="getMsuRatesFunc"
            @closeDialog="show.addLinked = false"
        />
    </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import PackagePage from './PackagePage.vue/IndexPage.vue'
import UpdateRate from './UpdateRate.vue'
import DeleteRate from './DeleteRate.vue'
import NewRate from './NewRate.vue'
import ShowHistory from './ShowHistory.vue'
import LikedPage from './LinkedPage/IndexPage.vue'
import NewLink from './LinkedPage/NewLink.vue'
import {
    mdiHeartPulse,
    mdiPlus,
    mdiEye,
    mdiLinkEdit,
    mdiLinkPlus,
    mdiFileEye,
    mdiPencil,
    mdiTrashCan
} from '@mdi/js'
export default {
    components: { UpdateRate, DeleteRate, NewRate, ShowHistory, PackagePage, LikedPage, NewLink },
    data: ()=>({
        mdiHeartPulse,
        mdiPlus,
        mdiEye,
        mdiLinkEdit,
        mdiLinkPlus,
        mdiFileEye,
        mdiPencil,
        mdiTrashCan,
        notif: {
            show: false,
            type: 'success',
            msg: 'Done',
            color: 'success'
        },
        rateItems: [],
        show: {
            addLinked: false,
            linked: false,
            packageData: null,
            package: false,
            historyData: null,
            history: false,
            new: false,
            update: false,
            delete: false,
            data: {
                ID : null,
                MSU_C: null,
                DIA_T: null,
                PHP_N: null,
                USE_HMI_RATE: false,
                RATE_TYPE: null,
                MIN_AGE: 0,
                MAX_AGE: 120,
                HIDE_AGE_RESTRICTION: false
            }
        },
        headers: [
            { text: 'No.', value: 'ROW_N', align: 'center' },
            { text: 'Diagnostic/Package Name', value: 'DIA_T' },
            { text: 'Rate Type', value: 'RATE_TYPE', align: 'center' },
            { text: 'Age', value: 'AGE' },
            { text: 'Price', value: 'PHP_N' },
            { text: 'Actions', value: 'ACTIONS', align: 'center' }
        ],
        selectedHosp: null,
        items: [],
        loading: false,
        screen_width: document.documentElement.clientWidth + 9
    }),
    computed: {
        ...mapGetters(['fetchAcuProvidersData', 'getMsuRatesData', 'editMsuRatesData', 'deleteMsuRatesData', 'addMsuRatesData', 'editDiagnosticPackageData'])
    },
    watch: {
        selectedHosp(newVal) {
            if (newVal === null) {
                this.rateItems = []
            }
        },
        notif: {
            handler(newVal) {
                if (newVal.show) {
                    if (newVal.timeout !== 0) {
                        setTimeout(() => {
                            this.notif.show = false
                        }, newVal.timeout)
                    }
                }
            },
            deep: true
        },
        addMsuRatesData(newVal) {
            if (newVal) {
                if (newVal.status === 200) {
                    this.notif.type = 'success'
                    this.notif.color = 'success'
                    this.notif.timeout = 5000
                    this.notif.msg = 'New rate has been added.'
                    this.notif.show = true
                    this.show.new = false
                    this.getMsuRatesFunc()
                } else {
                    this.notif.type = 'error'
                    this.notif.color = 'error'
                    this.notif.timeout = 5000
                    this.notif.msg = newVal.state
                    this.notif.show = true
                }
            }
        },
        deleteMsuRatesData(newVal) {
            if (newVal) {
                if (newVal.status === 200) {
                    this.notif.type = 'success'
                    this.notif.color = 'success'
                    this.notif.timeout = 5000
                    this.notif.msg = 'Rate has been deleted.'
                    this.notif.show = true
                    this.show.delete = false
                    this.getMsuRatesFunc()
                } else {
                    this.notif.type = 'error'
                    this.notif.color = 'error'
                    this.notif.timeout = 5000
                    this.notif.msg = newVal.state
                    this.notif.show = true
                }
            }
        },
        editMsuRatesData(newVal) {
            if (newVal) {
                if (newVal.status === 200) {
                    this.notif.type = 'success'
                    this.notif.color = 'success'
                    this.notif.timeout = 5000
                    this.notif.msg = 'Rate has been updated.'
                    this.notif.show = true
                    this.show.update = false
                    this.getMsuRatesFunc()
                } else {
                    this.notif.type = 'error'
                    this.notif.color = 'error'
                    this.notif.timeout = 5000
                    this.notif.msg = newVal.state
                    this.notif.show = true
                }
            }
        },
        fetchAcuProvidersData(newVal) {
            if (newVal && newVal.status === 200) {
                // List of hospitals to pin in the top of the items
                const validHospitalsAcceptingAcu = ['464', '016']
                let validHospitalsAcceptingAcuDetailed = []
                this.items = newVal.data
                let newArr = structuredClone(newVal.data)

                // Loop in each hospital, generate `nameAndCode` in each item and
                // move validHospitalsAcceptingAcu to validHospitalsAcceptingAcuDetailed
                for (let i=0; i<newArr.length; i++) {
                    newArr[i] = { ...newArr[i], nameAndCode: `${newArr[i].type === 'SINGLE' ? newArr[i].hosp_msu_code : newArr[i].group_id} ${newArr[i].hosp_name}` }
                    if (validHospitalsAcceptingAcu.some(element => newArr[i].hosp_msu_code ? newArr[i].hosp_msu_code.includes(element) : false)) {
                        validHospitalsAcceptingAcuDetailed.push(newArr.slice(i, i + 1)[0])
                    }
                }

                // Merge arrays to pin the validHospitalsAcceptingAcu
                newArr = [...validHospitalsAcceptingAcuDetailed, ...newArr]

                this.items = newArr
            }
            this.loading = false
        },
        getMsuRatesData(newVal) {
            if (newVal) {
                if (newVal.status === 200) {
                    this.rateItems = newVal.data ? (newVal.data).sort((a, b) => {
                        return a.ROW_N - b.ROW_N
                    }) : []
                } else {
                    this.rateItems = []
                }
            }
        }
    },
    created() {
        // this.getCsrfToken()
        this.suggestAcuDiagnostics()
    },
    mounted() {
        window.addEventListener('resize', this.onResize)
        this.loading = true
        this.fetchAcuProviders()
    },
    destroyed(){
        window.removeEventListener('resize', this.onResize)
    },
    methods: {
        ...mapActions(['fetchAcuProviders', 'getCsrfToken', 'getMsuRates', 'suggestAcuDiagnostics']),
        makeAgeStatement(item) {
            if (item.MIN_AGE && item.MIN_AGE > 0 && item.MAX_AGE && item.MAX_AGE < 120) {
                return `For ${item.MIN_AGE}-${item.MAX_AGE} y/o only`
            } else if (item.MIN_AGE && item.MIN_AGE > 0 && !(item.MAX_AGE && item.MAX_AGE < 120)) {
                return `For ${item.MIN_AGE} y/o and above only`
            } else if (item.MAX_AGE && item.MAX_AGE < 120 && !(item.MIN_AGE && item.MIN_AGE > 0)) {
                return `For ${item.MAX_AGE} y/o and below only`
            } else {
                return 'All Ages'
            }
        },
        showIndexPage(data, type) {
            this.showLinkedModal(data, type)
        },
        showLinkedModal(data, type) {
            this.show.data = data
            if (type === 'show') {
                this.show.linked = true
            } else {
                this.show.addLinked = true
            }
        },
        showPackage(data) {
            this.show.packageData = data
            this.show.package = true
        },
        showHistory(data) {
            this.show.historyData = data
            this.show.history = true
        },
        toFixedNoRound(num, decimals = 2) {
            const factor = Math.pow(10, decimals)
            return (Math.floor(num * factor) / factor).toFixed(decimals)
        },
        newRate() {
            this.show.data = {
                MSU_C: this.selectedHosp.type === 'SINGLE' ? this.selectedHosp.hosp_msu_code : this.selectedHosp.group_id,
                HOSP_NAME: this.selectedHosp.hosp_name,
                TYPE: this.selectedHosp.type
            }
            this.show.new = true
        },
        updateRate(item) {
            this.show.data = {
                ID : item.ID,
                MSU_C: item.MSU_C,
                DIA_T: item.DIA_T,
                PHP_N: item.PHP_N,
                USE_HMI_RATE: item.USE_HMI_RATE,
                RATE_TYPE: item.RATE_TYPE,
                TYPE: item.MSU_TYPE,
                MIN_AGE: item.MIN_AGE,
                MAX_AGE: item.MAX_AGE,
                HIDE_AGE_RESTRICTION: item.HIDE_AGE_RESTRICTION,
                ANNOTATION: item.ANNOTATION
            }
            this.show.update = true
        },
        deleteRate(item) {
            this.show.data = {
                ID : item.ID,
                MSU_C: item.MSU_C,
                DIA_T: item.DIA_T,
                PHP_N: item.PHP_N,
                USE_HMI_RATE: item.USE_HMI_RATE,
                RATE_TYPE: item.RATE_TYPE,
                TYPE: item.MSU_TYPE,
                MIN_AGE: item.MIN_AGE,
                MAX_AGE: item.MAX_AGE,
                HIDE_AGE_RESTRICTION: item.HIDE_AGE_RESTRICTION,
                ANNOTATION: item.ANNOTATION
            }
            this.show.delete = true
        },
        getMsuRatesFunc() {
            if (this.selectedHosp && (this.selectedHosp.type === 'SINGLE' && this.selectedHosp.hosp_msu_code || this.selectedHosp.type === 'GROUP' && this.selectedHosp.group_id)) {
                this.getMsuRates({ MSU_C: this.selectedHosp.type === 'SINGLE' ? this.selectedHosp.hosp_msu_code : this.selectedHosp.group_id })
            }
        },
        onResize() {
            this.screen_width = document.documentElement.clientWidth
            this.screen_width = this.screen_width + 9
        }
    }
}
</script>

<style scoped>
h1 {
    font-size: 25px;
    padding: 10px;
    border-bottom: 1px solid #bbb;
}
.docInfoBody {
    margin-top: 2%;
}
</style>
